import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_above_facility_meeting_measures_listed_above_regarding_4'

export const dataPointDefinition = {
  retracedId: 'none_above_facility_meeting_measures_listed_above_regarding_4',
  name: 'None of the above - the facility is meeting all measures listed above regarding elevator safety',
  description: 'Select "X" if the facility HAS a minimum of all safety measures described above.',
  meta: {
    slcpMeta: {
      key: 'hs-bui-45x',
      number: 'HS-BUI-9-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-39',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-12,Yes',
      machineShowHide: '[2],hs-12,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-45x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29740,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
